var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.34362 3.01932V5.88384H3.45396C1.98155 5.88384 1.49074 6.36127 1.49074 7.79353V13.5226H3.45396V11.6129C3.45396 10.1806 3.94477 9.70321 5.41718 9.70321H9.34362V12.5677L15.2333 7.79353L9.34362 3.01932Z",
    fill: "url(#paint0_linear_398_54597)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85288 2V5.40642H3.45402C2.69063 5.40642 2.02551 5.52402 1.57321 5.964C1.1209 6.40397 1 7.05094 1 7.79353V14H3.94483V11.6129C3.94483 10.9232 4.06933 10.6153 4.23053 10.4585C4.39173 10.3017 4.70823 10.1806 5.41724 10.1806H8.85288V13.5871L16 7.79353L8.85288 2ZM14.4667 7.79353L9.83449 11.5484V9.22579H5.41724C4.65385 9.22579 3.98873 9.34339 3.53643 9.78337C3.08412 10.2233 2.96322 10.8703 2.96322 11.6129V13.0452H1.98161V7.79353C1.98161 7.10384 2.10611 6.79598 2.26731 6.63917C2.42851 6.48237 2.74501 6.36126 3.45402 6.36126H9.83449V4.03863L14.4667 7.79353Z",
    fill: "#626262"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_398_54597",
    x1: 8.36201,
    y1: 3.01932,
    x2: 8.36201,
    y2: 13.5226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BBC9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.619ab37588346c1066b539d2d32fae4f.svg";
export { ForwardRef as ReactComponent };